function extractValuesFromXML(xmlText: string, values: Array<string>): Record<string, string> {
  const parser = new DOMParser();
  const xml: Document = parser.parseFromString(xmlText, 'text/xml');
  const valuesFromXml: Record<string, string> = {};
  values.forEach((value: string) => {
    const xmlNode = xml.getElementsByTagName(value);
    if (xmlNode) {
      const xmlValue = xmlNode[0].childNodes[0].nodeValue!; // esperemos que no sea null :)
      valuesFromXml[value] = xmlValue;
    }
  });
  return valuesFromXml;
}

export function cropToAspectRatio(file: File, aspectRatio: number): Promise<File> {
  return new Promise(async (resolve, reject) => {
    const img = new Image();
    img.src = URL.createObjectURL(file);
    img.onload = async () => {
      const originalWidth: number = img.width;
      const originalHeight: number = img.height;

      // Calculate new dimensions to maintain the aspect ratio
      let newWidth: number;
      let newHeight: number;
      let focalPointX: number;
      let focalPointY: number;
      if (originalWidth / originalHeight > aspectRatio) {
        newWidth = originalHeight * aspectRatio;
        newHeight = originalHeight;
        focalPointX = -((originalWidth / 2) - (newWidth / 2));
        focalPointY = 0;
      } else {
        newWidth = originalWidth;
        newHeight = originalWidth / aspectRatio;
        focalPointX = 0;
        focalPointY = -((originalHeight / 2) - (newHeight / 2));
      }

      // Create an off-screen canvas
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        console.error('error creating canvas context at cropToAspectRatio function', {
          file,
          aspectRatio,
        });
        return reject();
      }

      // Set canvas dimensions to the new dimensions
      canvas.width = newWidth;
      canvas.height = newHeight;

      // Draw the image on the canvas with the new dimensions
      ctx.drawImage(img, focalPointX, focalPointY, originalWidth, originalHeight);

      // Convert the canvas content to a data URL
      const croppedImageDataUrl = canvas.toDataURL(file.type);
      const base64Response = await fetch(croppedImageDataUrl);

      // Resolve the Promise
      return resolve(new File([await base64Response.blob()], file.name, { type: file.type }));
    };

    img.onerror = error => reject(error);
  });
}


export default extractValuesFromXML;
